import { defineMessages } from 'react-intl'

export default defineMessages({
  addFamilyMember: {
    id: 'familypage.addfamilymember',
    defaultMessage: 'Add family member',
  },
  ambetterDependentNoticeOver18: {
    id: 'familypage.ambetterdependentnoticeoverage',
    defaultMessage:
      'Dependents over the age of 18 covered on your health plan should create their own Babylon account to access our services at no cost.',
  },
  ambetterDependentNoticeUnder18: {
    id: 'familypage.ambetterdependentnoticeunderage',
    defaultMessage:
      'Dependents under the age of 18 get access to Babylon’s urgent care services only. Register them now.',
  },
  done: {
    id: 'familypage.done',
    defaultMessage: 'Done',
  },
  familyMemberAdded: {
    id: 'familypage.familymemberadded',
    defaultMessage: 'Family member added successfully.',
  },
  familyMemberEdited: {
    id: 'familypage.familymemberedited',
    defaultMessage: 'Family member edited successfully.',
  },
})
